import { DataTableId } from "./services";

export type PlatformDashboardLinks = ReturnType<typeof platformDashboardLinks>;

export const platformDashboardLinks = () =>{ 
  const prefix = "/"
  return {
    index:`${prefix}`,
    report :(reportKey:number, facilityReference?:string, bookmarkId?:string ) =>{
      const facilityReferencePart = facilityReference? `&facility=${facilityReference}` : ""; 
      const bookmarkPart = bookmarkId? `&bookmark=${bookmarkId}` : ""; 
      return `${prefix}?report-key=${reportKey}${facilityReferencePart}${bookmarkPart}`
    },
    packs:`${prefix}?packs`,
    //lists:`${prefix}?lists`,
    viewPack:(packId:number) => `${prefix}?packs&packId=${packId}`,
    badges:`${prefix}?badges`,
    workforce: (facilityReference:string) =>`${prefix}?workforce&facility=${facilityReference}`,
    workforceList: () =>`${prefix}?workforce`,
    manageFacility:`${prefix}?facility-management`,
    search:`${prefix}?search`
  } 
};



export const links =
{
  management: {
    reports: {
      detail: (reportKey: number): string => `/Management/Reports/Details/${reportKey}`
    }
  },
  facilityManagement:{
    createUser: (facilityReference:string) => `/?facility-management&ref=${facilityReference}&create`,
    facility: (facilityReference:string) => `/?facility-management&ref=${facilityReference}`,
    facilityUser: (facilityReference:string, userKey:number) => `/?facility-management&ref=${facilityReference}&userkey=${userKey}`
  },
  subscriber: (subscriberName: string) => ({
    reports: {
      detail: (reportKey: number): string => `/subscriber/${subscriberName}/reports/details/${reportKey}`,
      preview:(reportKey: number): string => `/subscriber/${subscriberName}/reports/details/${reportKey}`
    },
    practices:(practiceKey:number) =>({
      users:(): string => `/subscriber/${subscriberName}/Practices/Users/${practiceKey}`
    }),
    report:(reportKey: number) =>({
      preview:(username: string) =>`/subscriber/${subscriberName}/Reports/Preview/${reportKey}?username=${username}`,
      preview2:(username: string, facilityReference?:string) =>{
        var facilityPart = facilityReference ? `&facility=${facilityReference}`: ""
        return `/subscriber/${subscriberName}/Reports/Preview/${reportKey}?username=${username}${facilityPart}`
      }
    }),
    users:() =>({
      detail:(userKey: number) =>`/subscriber/${subscriberName.replace(" ","-")}/Users/Details/${userKey}`
    })
  }),
  login: (inactive: boolean, returnUrl: string) => {
    return `/Identity/Account/Login?${inactive ? "Inactive=true&" : ""}ReturnUrl=${encodeURIComponent(returnUrl)}`
  },
  blocked:'?blocked',
  onboarding:"?onboarding",
  inactive:() => 'Inactive',
  noDirectAccess:() => "/?no-direct-access",
  forbidden: () => {
    return `/?forbidden`
  },
  dashboard: platformDashboardLinks(),
  report:(reportKey:number) => ({
    documentation:(hashTag?: string) => `/documentation/${reportKey}${hashTag ? hashTag : ""}`
  }),
  lists:{
    list:(tableId:DataTableId) => `/?list&id=${tableId}`
  },
  measureCategoryView:(reportViewContext:{ facilityReference?:string, username?: string }, measureCategoryId:number) =>
  {
    return `/?measures&facility=${reportViewContext.facilityReference}&measure-cat=${measureCategoryId}`;
  }, 
  measureCategory:(reportViewContext:{ facilityReference?:string, username?: string }, measureCategoryId:number, target:"latest", measureId?:number) =>{
    const measureIdPart = measureId ? `&measure=${measureId}` : "";
    return `/?measures&facility=${reportViewContext.facilityReference}&measure-cat=${measureCategoryId}&${target}${measureIdPart}`
  },
  measureCategorySaved:(reportViewContext:{ facilityReference?:string, username?: string }, measureCategoryId:number,reportMeasureCategoryTableId:string) =>`?measures&facility=${reportViewContext.facilityReference}&measure-cat=${measureCategoryId}&table&report-measure-category-table=${reportMeasureCategoryTableId}`,
  export:(reportKey:number, exportKey:number, facilityReference?:string, username?: string) => {
    let url = `/export?report-key=${reportKey}&export-key=${exportKey}`;
    if (typeof username != 'undefined') {
      url = url +`&username=${username}`;
    }
    if (facilityReference) {
      url = url +`&facility=${facilityReference}`;
    }
    return url;
  },
  markdown: {
    preview: () => "/api/markdown/preview"
  },
  api: {
    measures: {
      list: (measureCategoryId: number, facilityReference: string) => new LinkBuilder('/api/measures/list').addPathSegment(facilityReference).addPathSegment(measureCategoryId).toString()
    }
  }
}


class LinkBuilder {
  search = new Map<string, any | undefined>();
  paths: string[] = [];

  constructor(public path: string) { }

  addPathSegment(pathSegment: any) {
    this.paths.push(pathSegment);
    return this
  }


  addQuery(key: string, value: any) {
    this.search.set(key, value);
    return this;
  }

  addQueryKey(key: string) {
    this.search.set(key, undefined);
    return this;
  }

  addOptionalQuery(key: string, value: any | undefined) {
    if (value != undefined) {
      return this.addQuery(key, value)
    }
    return this;
  }

  toString() {

    var url = this.path;
    for (const pathSegment of this.paths) {
      url += `/${pathSegment}`;
    }

    if (this.search.size > 0) {
      var searchDelimiter = url.includes("?") ? "&" : "?";
      for (const [key, value] of this.search.entries()) {
        const searchPart = value != undefined ? `${key}=${value}` : `${key}`
        url += `${searchDelimiter}${searchPart}`
        searchDelimiter = "&";
      }
    }

    return url;
  }

}